/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { Subject, BehaviorSubject } from 'rxjs';
export { RxEventHelper };
var RxEventHelper;
(function (RxEventHelper) {
    function create() {
        var helper = new _RxEventHelper();
        var ret = (function () { return helper.create(); });
        ret.dispose = function () { return helper.dispose(); };
        ret.behavior = function (v) { return helper.behavior(v); };
        return ret;
    }
    RxEventHelper.create = create;
})(RxEventHelper || (RxEventHelper = {}));
var _RxEventHelper = /** @class */ (function () {
    function _RxEventHelper() {
        this._eventList = [];
        this._disposed = false;
    }
    _RxEventHelper.prototype.create = function () {
        var s = new Subject();
        this._eventList.push(s);
        return s;
    };
    _RxEventHelper.prototype.behavior = function (v) {
        var s = new BehaviorSubject(v);
        this._eventList.push(s);
        return s;
    };
    _RxEventHelper.prototype.dispose = function () {
        if (this._disposed)
            return;
        for (var _i = 0, _a = this._eventList; _i < _a.length; _i++) {
            var e = _a[_i];
            e.complete();
        }
        this._disposed = true;
    };
    return _RxEventHelper;
}());
